import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import { useToggle } from '../../../core/hooks/useToggle';
import { Tooltip } from '../../Tooltip';
import { Close } from '../../../foundations/icons';
import styles from './TooltipWrapper.module.scss';
export var TooltipWrapper = function (_a) {
    var children = _a.children, tooltip = _a.tooltip;
    var _b = useToggle(false), isOpen = _b[0], open = _b[1], close = _b[2];
    var tooltipChild = useRef(null);
    useEffect(function () {
        if (!(tooltipChild === null || tooltipChild === void 0 ? void 0 : tooltipChild.current))
            return function () { };
        var callback = function (mutationList) {
            mutationList.forEach(function (mutation) {
                if (mutation.attributeName === 'class' &&
                    mutation.target.classList.contains('close')) {
                    close();
                }
            });
        };
        /**
         * Logic to detect a change made in childrenWrapper by useForceFocus on carousel
         * This prevents the tooltip to be visible if the element is not visible / focusable
         */
        var observer = new MutationObserver(callback);
        observer === null || observer === void 0 ? void 0 : observer.observe(tooltipChild.current, { attributes: true });
        return function () {
            observer.disconnect();
        };
    }, [close]);
    if (!tooltip)
        return children;
    return (React.createElement("div", { "data-testid": "tooltipWrapper", ref: tooltipChild, className: styles.tooltipWrapper },
        React.createElement(Tooltip, { content: React.createElement(React.Fragment, null,
                tooltip,
                React.createElement("div", { className: styles.tooltipCloseIcon },
                    React.createElement(Close, { "data-testid": "close", size: "xsmall", onClick: function (event) {
                            event.preventDefault();
                            close();
                        } }))), placement: "bottom-end", className: styles.tooltipBackground, isOpen: isOpen },
            React.createElement("button", { onClick: open, className: classnames('tooltipButton', styles.childrenWrapper), "data-testid": "childrenWrapper" }, children))));
};
//# sourceMappingURL=index.js.map